/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useMemo, useState } from 'react';
import Style from './DuvidasFrequentesPerguntas.css';
import Container from '../../atoms/Container';
import { duvidasPerguntas } from './DuvidasFrequentesListaPerguntas';
import { isMobile } from '../../../utils/browser';

function DuvidasFrequentesPerguntas() {
  const [search, setSearch] = useState('');
  const [answersToShow, setAnswerToShow] = useState(duvidasPerguntas[0]);
  const [open, setOpen] = useState('');
  const [visible, setVisible] = useState('');

  const handleFilterAnswers = (tema, value) => {
    setOpen('');
    setVisible(true);
    if (!!search) {
      setSearch('');
    }
    setAnswerToShow(duvidasPerguntas[value]);
    window.scrollTo(0, isMobile() ? 598 : 481);
  };

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen('');
    setVisible(true);
    if (!!search) {
      const temp = duvidasPerguntas.map((a) => a.perguntas).flat(1);
      const filtered = temp.filter(
        (a) =>
          a.respostas.toUpperCase().includes(search.toUpperCase()) ||
          a.pergunta.toUpperCase().includes(search.toUpperCase()),
      );
      setAnswerToShow({ tema: 'BUSCA', perguntas: filtered });
    } else {
      setAnswerToShow(duvidasPerguntas[0]);
    }
  };

  const handleCloseSearch = () => {
    setSearch('');
    setVisible(false);
    setAnswerToShow(duvidasPerguntas[0]);
  };

  useEffect(() => {
    if (isMobile()) {
      return;
    }
    if (!!search) {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const renderPerguntas = useMemo(() => answersToShow.perguntas ?? [], [answersToShow]);
  const renderTema = useMemo(() => answersToShow.tema ?? 'Busca', [answersToShow.tema]);

  return (
    <>
      <section id="duvidas-perguntas">
        <Container>
          <div className="duvida-perguntas-box">
            {/* <h2 className="duvida-perguntas-title">Dúvidas frequentes</h2> */}
            <form className="duvida-div-search" onSubmit={(e) => handleSearch(e)}>
              <button type="submit" onClick={handleSearch}>
                <img src="assets/duvidas-frequentes/ic_search.svg" alt="" />
              </button>
              <input
                type="text"
                placeholder="Buscar"
                value={search}
                onChange={(e) => {
                  const temp = e.target.value;
                  setSearch(temp);
                }}
                content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
                onKeyUp={(event) => {
                  if (isMobile()) {
                    if (event.key === 'Enter') {
                      try {
                        if (!!search) {
                          handleSearch();
                        }
                        event.target.blur();
                      } catch (e) {
                        console.error(e);
                      }
                    }
                  }
                }}
              />
              {!!search && (
                <button type="submit" onClick={handleCloseSearch}>
                  <img className="close-search" src="assets/shared/s_close.svg" alt="" />
                </button>
              )}
            </form>
            <div className="duvida-perguntas-content">
              <div className="duvida-perguntas-temas">
                <div className="duvida-perguntas-content-temas">
                  {duvidasPerguntas.map((a, i) => {
                    return (
                      <button
                        key={`${a.tema}-${i}`}
                        className={`duvida-perguntas-temas-btn ${
                          renderTema == a.tema ? 'selected' : ''
                        }`}
                        onClick={() => handleFilterAnswers(a.tema, i)}
                      >
                        <div>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: a.tema,
                            }}
                          />
                          <img src="assets/duvidas-frequentes25/ic-arrow-right.svg" alt="" />
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className={`duvida-perguntas-respostas ${visible == true ? 'visible' : ''}`}>
                <div onClick={handleCloseSearch} className="btn-voltar">
                  <img src="assets/duvidas-frequentes25/ic-arrow-left-red.svg" alt="" /> Voltar
                </div>
                <h3 className="duvida-perguntas-content-title">Perguntas e respostas</h3>

                <div className="duvida-perguntas-content-respostas">
                  {renderPerguntas.map((a, pindex) => {
                    return (
                      <div
                        key={`${renderTema}-${a.pergunta}-${pindex}`}
                        className={`duvida-perguntas-content-respostas-acc ${
                          open == a.pergunta ? 'activated' : ''
                        }`}
                      >
                        <div
                          className="duvida-perguntas-content-respostas-title-div"
                          onClick={() => {
                            if (open == a.pergunta) {
                              setOpen('');
                              return;
                            }

                            setOpen(a.pergunta);
                          }}
                        >
                          <p className="duvida-perguntas-content-respostas-title">{a.pergunta}</p>
                          <img
                            className="duvida-perguntas-content-respostas-img"
                            src="assets/duvidas-frequentes25/ic_arrow_down.svg"
                            alt=""
                          />
                        </div>
                        <p
                          className="duvida-perguntas-content-respostas-acc-text"
                          dangerouslySetInnerHTML={{
                            __html: a.respostas,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default DuvidasFrequentesPerguntas;
